import React, { useState, useEffect } from "react";
import { Card, Grid, Sticky, Button, Icon, Dimmer, Loader } from "semantic-ui-react";
import { Navigate, useNavigate } from "react-router-dom";
import "../css/Events.css";
import "../css/RSO.css";
import "../css/MyRSOs.css";

export default function ApproveRSOs() {
    const [approveRSOList, setApproveRSOList] = useState([]);
    const [updateCheck, setUpdateCheck] = useState(0);
    let navigate = useNavigate();

    useEffect(() => {
        console.log(localStorage.getItem("uniid"));
        handleGetApproveRSO()
        console.log("all rso to approve");
        console.log(approveRSOList);
    }, []);

    useEffect(() => {
        handleGetApproveRSO()
    }, [updateCheck]);

    const redirectLogin = () => {
        localStorage.clear();
        navigate("/");
    };

    const redirectUniversity = () => {
        navigate("/MyUniversity");
    };

    const redirectRSO = () => {
        navigate("/RSO");
    };

    const redirectApproveRSO = () => {
        navigate("/ApproveRSOs");
    };

    const redirectApproveEvent = () => {
        navigate("/ApproveEvents");
    };

    //FIX NAVIGATION LINK
    const redirectEvent = () => {
        navigate("/Events");
    };

    async function handleGetApproveRSO() {
        try {
            let info = {
                uniid: localStorage.getItem("uniid")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listRSOsToApprove.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log("This is the response error: " + res.error);

            if (res.error === "") {
                setApproveRSOList(res.results);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleApprove = (event) => (e) => {
        handleApproveHelper(event);
    };

    async function handleApproveHelper(event) {
        try {
            let info = {
                rsoid: event.rsoid
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/approveRSO.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "applicaton/json" },
                }
            );

            let res = await response.json();

            console.log("Error message: " + res.error);

            if (res.error === "") {
                setUpdateCheck(updateCheck + 1);
            } else {
                alert(res.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="ui center aligned padded grid">
            <div className="row events-row">
                <div className="events-blue-sidebar column three wide">
                    <h2 className="events-hi-user">Hi, {localStorage.getItem("first")}</h2>
                    <p className="events-subpage-link" onClick={redirectUniversity}>My University</p>
                    <p className="events-subpage-link" onClick={redirectApproveRSO}>Approve RSOs</p>
                    <p className="events-subpage-link" onClick={redirectApproveEvent}>Approve Events</p>
                    <h2 className="events-sidebar-subtitle">EXPLORE</h2>
                    <p className="events-subpage-link" onClick={redirectRSO}>RSOs</p>
                    <p className="events-subpage-link" onClick={redirectEvent}>Events</p>
                    <Button icon onClick={redirectLogin}>
                        <Icon className="event-icon2" name='sign-out' size='large' />
                    </Button>
                </div>
                <div className="events-right-container column thirteen wide">
                    <h2 className="MyRSO-titletwo">
                        RSOs to Approve:
                    </h2>
                    <div className="events-event-cards-container">
                        {(approveRSOList.length !== 0) ?
                        (approveRSOList.map((event) => (
                            <div className="RSO-card-container">
                                {!approveRSOList.some(
                                (approvedEvent) =>
                                    approvedEvent.results ===
                                    "No Records") ? (
                                <Card fluid>
                                    <Grid
                                        container
                                        columns={3}
                                        className="RSO-grid-card"
                                    >
                                        <Grid.Column>
                                            <h2 className="RSO-name">
                                                {event.name}
                                            </h2>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="RSO-description">
                                                {event.description}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Button
                                                color="blue"
                                                size="massive"
                                                className="RSO-button"
                                                onClick={handleApprove(event)}
                                            >
                                                APPROVE RSO
                                            </Button>
                                        </Grid.Column>
                                    </Grid>
                                </Card>
                                ):(<h3>No RSOs Needing Approval</h3>)}
                            </div>
                        ))) :
                        (<Dimmer active inverted>
                            <Loader inverted content='Loading' />
                        </Dimmer>)}
                    </div>
                </div>
            </div>
        </div>
    );
}